import axios from 'axios'
import qs from 'qs'

// import store from '@/store'
import { Toast,Dialog } from 'vant'
// 根据环境不同引入不同api地址
import { baseApi } from '@/config'
import store from '@/store'
import { getToken, getUserInfo } from './storage'
// create an axios instance
const service = axios.create({
  baseURL: baseApi, // url = base api url + request url
  withCredentials: true, // send cookies when cross-domain requests
  // timeout: 5000 // request timeout
})

let message = false
// request拦截器 request interceptor
service.interceptors.request.use(
  config => {
    if (config.method === 'post') {
      config.data = qs.stringify(config.data,{indices:false})
    }
    // 不传递默认开启loading
    if (!config.hideloading) {
      // loading
      Toast.loading({
        forbidClick: true
      })
    }
    // if (getToken()) {
    //   config.headers['authorization'] = getToken()
    // }
    // let userInfo = getUserInfo() ? JSON.parse(getUserInfo()) : ''
    // if (userInfo) {
    //   // config.headers['authorization'] = userInfo.token
    //   config.headers['openid'] = userInfo.openid
    //   config.headers['unionid'] = userInfo.unionid
    // }
    return config
  },
  error => {
    // do something with request error
    console.log(error) // for debug
    return Promise.reject(error)
  }
)
// respone拦截器
service.interceptors.response.use(
  response => {
    Toast.clear()
    const res = response.data
    // if (res.code == 200) {
    //   message = false
    //   return Promise.resolve(res)
    // } else if (res.code == 302) {// 登录超时,重新登录
    //   if (!message) {
    //     message = true
    //     localStorage.removeItem('token')
    //     Dialog.alert({ message: res.msg }).then(() => {
    //       store.dispatch('setAuthorization')
    //     })
    //   }
    // } else {
    //   message = false
    //   Dialog.alert({ message: res.msg }).then(() => {
    //     var u = navigator.userAgent
    //     if (u.indexOf('miniProgram') !== -1) {
    //       window.wx.miniProgram.reLaunch({ url: '/pages/index/index' })
    //     } else {
    //       window.location.href = window.location.href
    //       window.location.reload()
    //     }
    //   })
    //   return Promise.reject(res || 'error')
    // }
    if (res.status == 0) {
      message = false
      return Promise.resolve(res)
    } else if (res.status == 2) {// 登录超时,重新登录
      if (!message) {
        message = true
        sessionStorage.setItem('url',location.href)
        // let url = 'http://' + window.location.host + '/codeFirm.html'
        // let url = window.location.origin + window.location.pathname + 'codeFirm.html'
        var a = document.createElement("a")
        a.setAttribute("href", "codeFirm.html")
        var url = a.href
        location.href = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx64422800da4015b7&redirect_uri=' + url + '&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect'
      }
    } else if (res.status == 6 || res.status == 7) {
      return Promise.reject(res)
    } else {
      message = false
      Dialog.alert({ message: res.error.msg }).then(() => {
        // var u = navigator.userAgent
        // if (u.indexOf('miniProgram') !== -1) {
        //   window.wx.miniProgram.reLaunch({ url: '/pages/index/index' })
        // } else {
        //   window.location.href = window.location.href
        //   window.location.reload()
        // }
      })
      return Promise.reject(res || 'error')
    }
  },
  error => {
    Toast.clear()
    console.log('err' + error) // for debug
    Dialog.alert({ message: '请求失败' }).then(() => {
      // var u = navigator.userAgent
      // if (u.indexOf('miniProgram') !== -1) {
      //   window.wx.miniProgram.reLaunch({ url: '/pages/index/index' })
      // } else {
      //   window.location.href = window.location.href
      //   window.location.reload()
      // }
    })
    return Promise.reject(error)
  }
)

export default service
